import type { StyleLayer } from './utils/types'

export const layers_radinfra_traffic_signs: StyleLayer[] = [
  {
    id: 'hitarea-missing-sign',
    type: 'line',
    filter: [
      '!',
      [
        'any',
        ['has', 'traffic_sign'],
        ['has', 'traffic_sign:forward'],
        ['has', 'traffic_sign:backward'],
      ],
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'rgb(216, 20, 255)',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
  {
    id: 'sign-missing',
    type: 'line',
    filter: [
      '!',
      [
        'any',
        ['has', 'traffic_sign'],
        ['has', 'traffic_sign:forward'],
        ['has', 'traffic_sign:backward'],
      ],
    ],
    minzoom: 8,
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fda5e4',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-opacity': 0.6,
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 20, 4],
    },
  },
  {
    id: 'sign-colors',
    type: 'line',
    filter: [
      'any',
      ['has', 'traffic_sign'],
      ['has', 'traffic_sign:forward'],
      ['has', 'traffic_sign:backward'],
    ],
    minzoom: 8,
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'traffic_sign'],
        ['none'],
        '#00c29e',
        ['match', ['get', 'traffic_sign:forward'], ['none'], '#00c29e', '#a1e217'],
      ],
      'line-opacity': 0.6,
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
  {
    id: 'current-zoomed-out-traffic-signs',
    type: 'line',
    filter: ['!', ['has', 'traffic_sign']],
    maxzoom: 9,
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': 'gray',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
]
